import { defineMessages } from 'react-intl';

export const documentsSectionMessages = defineMessages({
  sectionTitle: {
    defaultMessage: 'Documents',
    id: 'rAbxmw',
    description: 'Title of the documents card in the freight details view',
  },
  billOfLading: {
    defaultMessage: 'Bill of Lading',
    id: 'um7UTU',
    description: 'Label for the bill of lading document row',
  },
  palletLabel: {
    defaultMessage: 'Pallet Labels',
    id: 'W4lqnp',
    description: 'Label for the pallet labels document row',
  },
  packingList: {
    defaultMessage: 'Packing List',
    id: '5wqlk5',
    description: 'Label for the packing list document row',
  },
  print: {
    defaultMessage: 'Print',
    id: 'jwTQCP',
    description: 'Label for the button that prints a freight document',
  },
  quote: {
    defaultMessage: 'Rate Quote',
    id: '7kdydK',
    description: 'Label for the rate quote document row',
  },
  proofOfDelivery: {
    defaultMessage: 'Proof of Delivery',
    id: 'ORSZP2',
    description: 'Label for the proof of delivery document row',
  },
  weightAndInspection: {
    defaultMessage: 'Weight and Inspection',
    id: 'dM8tnl',
    description: 'Label for the weight and inspection document row',
  },
  accessorialsReceipt: {
    defaultMessage: 'Accessorials Receipt',
    id: 'JQHgQq',
    description: 'Label for the accessorials receipt document row',
  },
  bolPalletLabelCombined: {
    defaultMessage: 'BOL / Pallet Label Combined',
    id: '6XggWY',
    description: 'Label for the combined bill of lading and pallet label document row',
  },
  certificateOfInsurance: {
    defaultMessage: 'Certificate of Insurance',
    id: 'Wrn36l',
    description: 'Label for the certificate of insurance document row',
  },
  certificateOfInsuranceInstructions: {
    defaultMessage: 'Certificate of Insurance Instructions',
    id: 'ZXiybM',
    description: 'Label for the certificate of insurance instructions document row',
  },
  certificateOfOriginUs: {
    defaultMessage: 'Certificate of Origin (US)',
    id: '8c2WJO',
    description: 'Label for the US certificate of origin document row',
  },
  certificateOfOriginUsmca: {
    defaultMessage: 'Certificate of Origin (USMCA)',
    id: 'To05hw',
    description: 'Label for the USMCA certificate of origin document row',
  },
  certificateOfOriginUsmcaInstructions: {
    defaultMessage: 'Certificate of Origin (USMCA) Instructions',
    id: 'mAFekR',
    description: 'Label for the USMCA certificate of origin instructions document row',
  },
  internationalCommercialInvoice: {
    defaultMessage: 'International Commercial Invoice',
    id: 'MFDc+/',
    description: 'Label for the international commercial invoice document row',
  },
  palletLabel4x6: {
    defaultMessage: 'Pallet Label (4x6)',
    id: 't6dic7',
    description: 'Label for the 4x6 pallet label document row',
  },
  other: {
    defaultMessage: 'Other',
    id: 'wVTyIy',
    description: 'Generic fallback label for an unrecognized freight document type',
  },
  download: {
    defaultMessage: 'Download',
    id: 'fSlokC',
    description: 'Aria label for the button that downloads a freight document',
  },
  share: {
    defaultMessage: 'Share',
    id: 'uAoybl',
    description: 'Aria label for the button that shares a freight document',
  },
  availableAfterDelivery: {
    defaultMessage: 'This will become available after delivery',
    id: 'RMWosp',
    description: 'Subtitle shown on a freight document row that is not yet available',
  },
  noDocuments: {
    defaultMessage: 'No documents available for this shipment.',
    id: 'K4G2Wx',
    description: 'Empty-state message shown when a freight shipment has no documents',
  },
  actions: {
    defaultMessage: 'Actions',
    id: 'X8W8ID',
    description: 'Label for the Actions dropdown button in the Documents section header',
  },
  printAll: {
    defaultMessage: 'Print All',
    id: '9B/SIo',
    description: 'Menu item that prints all freight documents for a shipment',
  },
  downloadAll: {
    defaultMessage: 'Download All',
    id: 'W//X6Y',
    description: 'Menu item that downloads all freight documents for a shipment',
  },
  shareAll: {
    defaultMessage: 'Share All',
    id: '3KnPJJ',
    description: 'Menu item that shares all freight documents for a shipment',
  },
  creatingDocuments: {
    defaultMessage: 'Creating shipment documents...',
    id: 'uRmlVx',
    description: 'Loading-state heading shown while freight documents are being generated',
  },
  creatingDocumentsSubtext: {
    defaultMessage: 'This can take a few seconds.',
    id: 'j0fP9K',
    description: 'Loading-state subtext shown while freight documents are being generated',
  },
});
